import axiosInstance from '../config/axios.js';
import { downloadBlob } from '../utils/downloadBlob.js';

const API_BASE = '/report';
const PDF_BASE = '/report/pdf';

const EXCEL_PATHS = {
  user: 'user',
  location: 'location',
  vehicle: 'vehicle',
  'ml-sheet': 'ml-sheet',
  shipment: 'shipment',
  expense: 'expense',
  'on-contract': 'on-contract',
  'vehicle-contract': 'vehicle-contract',
  'trip-contract': 'trip-contract',
  hr: 'hr',
  commission: 'commission',
  'external-commission': 'external-commission',
  'daily-business': 'daily-business',
  'route-pl': 'route-pl',
  receive: 'receive',
  'delivery-event': 'delivery-event',
  ewaybills: 'ewaybills',
  receivable: 'receivable',
  'approved-transactions': 'approved-transactions',
  'goods-balance': 'goods-balance',
  'onaccount-credit': 'onaccount-credit',
  'party-booking': 'party-booking',
  'invoice-cancellation': 'invoice-cancellation',
  'branch-payable': 'branch-payable',
  'hub-branch-agents': 'hub-branch-agents',
  'daily-branch': 'daily-branch',
  'agent-tds': 'agent-tds',
  business: 'business',
  'gst-collection': 'gst-collection',
};

function _dateStamp() {
  return new Date().toISOString().split('T')[0];
}

function _triggerDownload(blobData, filename) {
  return downloadBlob(blobData, filename);
}

function _toQuery(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      v.forEach((item) => {
        if (item !== '' && item != null) qs.append(k, item);
      });
    } else if (v !== '' && v !== null && v !== undefined) {
      qs.append(k, v);
    }
  });
  return qs.toString();
}

async function _downloadBlob(url, filename, params = {}) {
  const qs = _toQuery(params);
  const response = await axiosInstance.get(qs ? `${url}?${qs}` : url, {
    responseType: 'blob',
  });
  await _triggerDownload(response.data, filename);
  return response;
}

const reportService = {
  getReportData: async (type, params = {}) => {
    const qs = _toQuery(params);
    const path = `${API_BASE}/${type}/data${qs ? `?${qs}` : ''}`;
    const response = await axiosInstance.get(path);
    return response.data;
  },

  getReportInsights: async (type, params = {}) => {
    const qs = _toQuery(params);
    const response = await axiosInstance.get(`${API_BASE}/${type}/insights${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  downloadExcel: async (type, params = {}) => {
    const path = EXCEL_PATHS[type];
    if (!path) throw new Error(`Unknown report type: ${type}`);
    return _downloadBlob(
      `${API_BASE}/${path}`,
      `${type.replace(/-/g, '_')}_report_${_dateStamp()}.xlsx`,
      params,
    );
  },

  downloadPdf: async (type, params = {}) => {
    const path = EXCEL_PATHS[type];
    if (!path) throw new Error(`Unknown report type: ${type}`);
    return _downloadBlob(
      `${PDF_BASE}/${path}`,
      `${type.replace(/-/g, '_')}_report_${_dateStamp()}.pdf`,
      params,
    );
  },

  // Legacy helpers (still used elsewhere if needed)
  downloadUserReport: (params) => reportService.downloadExcel('user', params),
  downloadLocationReport: (params) => reportService.downloadExcel('location', params),
  downloadVehicleReport: (params) => reportService.downloadExcel('vehicle', params),
  downloadMLSheetReport: (params) => reportService.downloadExcel('ml-sheet', params),
  downloadShipmentReport: (params) => reportService.downloadExcel('shipment', params),
  downloadExpenseReport: (params) => reportService.downloadExcel('expense', params),
  downloadOnContractReport: (params) => reportService.downloadExcel('on-contract', params),
  downloadVehicleContractReport: (params) => reportService.downloadExcel('vehicle-contract', params),
  downloadTripContractReport: (params) => reportService.downloadExcel('trip-contract', params),
  downloadHrReport: (params) => reportService.downloadExcel('hr', params),
  downloadCommissionReport: (params) => reportService.downloadExcel('commission', params),
  downloadExternalCommissionReport: (params) => reportService.downloadExcel('external-commission', params),
};

export default reportService;
